// Pulse dashboard cards an org_admin can hide. Missing keys stay ON.
export const DASH_WIDGETS = [
  { id: "health", title: "Org health", blurb: "Hours, active people, idle, goals" },
  { id: "projects", title: "Projects", blurb: "Where the organisation spent itself" },
  { id: "people", title: "People", blurb: "Every person, in one picture" },
  { id: "attention", title: "Needs attention", blurb: "Silent people and flags" },
  { id: "dayDial", title: "Day shape", blurb: "The shape of a working day" },
  { id: "rhythm", title: "Day by day", blurb: "Active vs idle by day" },
  { id: "weekHeatmap", title: "Week heatmap", blurb: "When the company is online" },
  { id: "split", title: "Active vs idle", blurb: "Where the time went" },
  { id: "tools", title: "Apps & websites", blurb: "What the company works inside" },
];

export const DASH_WIDGET_IDS = DASH_WIDGETS.map((w) => w.id);

export function allDashWidgetsOn() {
  return DASH_WIDGET_IDS.reduce((acc, id) => {
    acc[id] = true;
    return acc;
  }, {});
}

export function normalizeDashWidgets(raw) {
  const src = raw && typeof raw === "object" ? raw : {};
  const widgetsSrc = src.widgets && typeof src.widgets === "object" ? src.widgets : src;
  const widgets = allDashWidgetsOn();
  DASH_WIDGET_IDS.forEach((id) => {
    if (widgetsSrc[id] === false) widgets[id] = false;
  });
  return widgets;
}

export function isDashWidgetOn(widgets, id) {
  return widgets?.[id] !== false;
}
